<div class="wrapper">
  <div class="title-wrapper">
    <div class="title">Filtres</div>
    <div class="clear" (click)="onClear()">Effacer les filtres</div>
  </div>
  <form class="form">
    <div class="filed">
      <div class="head">
        <label for="numero">Numéro civique</label>
        <span
          class="selection-count"
          *ngIf="selectedFilters['numero_civique']?.length"
        >
          {{ selectedFilters['numero_civique'].length }} sélection{{
            selectedFilters['numero_civique'].length > 1 ? 's' : ''
          }}
        </span>
      </div>
      <div
        class="container"
        *ngIf="!showFiltersMap['numero_civique']"
        (click)="toggleFilters('numero_civique')"
      >
        <span>Afficher les filtres</span>
        <svg
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#095797"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M6 9l6 6 6-6"></path>
        </svg>
      </div>
      <!-- Affichage du filtre uniquement si showFilters est vrai -->
      <div *ngIf="showFiltersMap['numero_civique']" class="container-true">
        <div (click)="toggleFilters('numero_civique')" class="filter-close">
          <span>Masquer les filtres</span>
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#095797"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M6 9l6 -6 6 6"></path>
          </svg>
        </div>
        <div class="search-bar">
          <input
            class="search-input"
            type="text"
            [formControl]="searchControls['numero_civique']"
          />
          <img
            src="assets/images/loop.svg"
            alt="Rechercher"
            class="search-icon"
          />
        </div>
        <div class="checkbox-list">
          <div *ngFor="let number of filterOptions['numero_civique']">
            <mat-checkbox
              class="custom-checkbox"
              (change)="onChange('numero_civique', number.toLowerCase())"
              [checked]="
                selectedFilters['numero_civique']?.includes(
                  number.toLowerCase()
                )
              "
              >{{ number }}</mat-checkbox
            >
          </div>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>
    <div class="filed">
      <div class="head">
        <label for="rue">Rue</label>
        <span class="selection-count" *ngIf="selectedFilters['rue']?.length">
          {{ selectedFilters['rue'].length }} sélection{{
            selectedFilters['rue'].length > 1 ? 's' : ''
          }}
        </span>
      </div>
      <div
        class="container"
        *ngIf="!showFiltersMap['rue']"
        (click)="toggleFilters('rue')"
      >
        <span>Afficher les filtres</span>
        <svg
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#095797"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M6 9l6 6 6-6"></path>
        </svg>
      </div>
      <!-- Affichage du filtre uniquement si showFilters est vrai -->
      <div *ngIf="showFiltersMap['rue']" class="container-true">
        <div (click)="toggleFilters('rue')" class="filter-close">
          <span>Masquer les filtres</span>
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#095797"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M6 9l6 -6 6 6"></path>
          </svg>
        </div>
        <div class="search-bar">
          <input
            class="search-input"
            type="text"
            [formControl]="searchControls['rue']"
          />
          <img
            src="assets/images/loop.svg"
            alt="Rechercher"
            class="search-icon"
          />
        </div>
        <div class="checkbox-list">
          <div *ngFor="let rue of filterOptions['rue']">
            <mat-checkbox
              class="custom-checkbox"
              (change)="onChange('rue', rue.toLowerCase())"
              [checked]="selectedFilters['rue']?.includes(rue.toLowerCase())"
              >{{ rue }}</mat-checkbox
            >
          </div>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>
    <div class="filed">
      <div class="head">
        <label for="ville">Ville ou municipalité</label>
        <span
          class="selection-count"
          *ngIf="selectedFilters['ville_municipalite']?.length"
        >
          {{ selectedFilters['ville_municipalite'].length }} sélection{{
            selectedFilters['ville_municipalite'].length > 1 ? 's' : ''
          }}
        </span>
      </div>
      <div
        class="container"
        *ngIf="!showFiltersMap['ville_municipalite']"
        (click)="toggleFilters('ville_municipalite')"
      >
        <span>Afficher les filtres</span>
        <svg
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#095797"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M6 9l6 6 6-6"></path>
        </svg>
      </div>
      <!-- Affichage du filtre uniquement si showFilters est vrai -->
      <div *ngIf="showFiltersMap['ville_municipalite']" class="container-true">
        <div (click)="toggleFilters('ville_municipalite')" class="filter-close">
          <span>Masquer les filtres</span>
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#095797"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M6 9l6 -6 6 6"></path>
          </svg>
        </div>
        <div class="search-bar">
          <input
            class="search-input"
            type="text"
            [formControl]="searchControls['ville_municipalite']"
          />
          <img
            src="assets/images/loop.svg"
            alt="Rechercher"
            class="search-icon"
          />
        </div>
        <div class="checkbox-list">
          <div
            *ngFor="
              let ville_municipalite of filterOptions['ville_municipalite']
            "
            [value]="ville_municipalite"
          >
            <mat-checkbox
              class="custom-checkbox"
              (change)="
                onChange('ville_municipalite', ville_municipalite.toLowerCase())
              "
              [checked]="
                selectedFilters['ville_municipalite']?.includes(
                  ville_municipalite.toLowerCase()
                )
              "
              >{{ ville_municipalite }}</mat-checkbox
            >
          </div>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>
    <div class="filed">
      <div class="head">
        <label for="numero_immeuble">Numéro d'immeuble</label>
        <span
          class="selection-count"
          *ngIf="selectedFilters['numero_immeuble']?.length"
        >
          {{ selectedFilters['numero_immeuble'].length }} sélection{{
            selectedFilters['numero_immeuble'].length > 1 ? 's' : ''
          }}
        </span>
      </div>
      <div
        class="container"
        *ngIf="!showFiltersMap['numero_immeuble']"
        (click)="toggleFilters('numero_immeuble')"
      >
        <span>Afficher les filtres</span>
        <svg
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#095797"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M6 9l6 6 6-6"></path>
        </svg>
      </div>
      <!-- Affichage du filtre uniquement si showFilters est vrai -->
      <div *ngIf="showFiltersMap['numero_immeuble']" class="container-true">
        <div (click)="toggleFilters('numero_immeuble')" class="filter-close">
          <span>Masquer les filtres</span>
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#095797"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M6 9l6 -6 6 6"></path>
          </svg>
        </div>
        <div class="search-bar">
          <input
            class="search-input"
            type="text"
            [formControl]="searchControls['numero_immeuble']"
          />
          <img
            src="assets/images/loop.svg"
            alt="Rechercher"
            class="search-icon"
          />
        </div>
        <div class="checkbox-list">
          <div
            *ngFor="let numero_immeuble of filterOptions['numero_immeuble']"
            [value]="numero_immeuble"
          >
            <mat-checkbox
              class="custom-checkbox"
              (change)="
                onChange('numero_immeuble', numero_immeuble.toLowerCase())
              "
              [checked]="
                selectedFilters['numero_immeuble']?.includes(
                  numero_immeuble.toLowerCase()
                )
              "
              >{{ numero_immeuble }}</mat-checkbox
            >
          </div>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>
    <div class="filed">
      <div class="head">
        <label for="direction">Direction immobilière</label>
        <span
          class="selection-count"
          *ngIf="selectedFilters['direction_immobiliere_nom']?.length"
        >
          {{ selectedFilters['direction_immobiliere_nom'].length }} sélection{{
            selectedFilters['direction_immobiliere_nom'].length > 1 ? 's' : ''
          }}
        </span>
      </div>
      <div
        class="container"
        *ngIf="!showFiltersMap['direction_immobiliere_nom']"
        (click)="toggleFilters('direction_immobiliere_nom')"
      >
        <span>Afficher les filtres</span>
        <svg
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#095797"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M6 9l6 6 6-6"></path>
        </svg>
      </div>
      <!-- Affichage du filtre uniquement si showFilters est vrai -->
      <div
        *ngIf="showFiltersMap['direction_immobiliere_nom']"
        class="container-true"
      >
        <div
          (click)="toggleFilters('direction_immobiliere_nom')"
          class="filter-close"
        >
          <span>Masquer les filtres</span>
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#095797"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M6 9l6 -6 6 6"></path>
          </svg>
        </div>
        <div class="search-bar">
          <input
            class="search-input"
            type="text"
            [formControl]="searchControls['direction_immobiliere_nom']"
          />
          <img
            src="assets/images/loop.svg"
            alt="Rechercher"
            class="search-icon"
          />
        </div>
        <div class="checkbox-list">
          <div
            *ngFor="
              let direction_immobiliere_nom of filterOptions[
                'direction_immobiliere_nom'
              ]
            "
            [value]="direction_immobiliere_nom"
          >
            <mat-checkbox
              class="custom-checkbox"
              (change)="
                onChange(
                  'direction_immobiliere_nom',
                  direction_immobiliere_nom.toLowerCase()
                )
              "
              [checked]="
                selectedFilters['direction_immobiliere_nom']?.includes(
                  direction_immobiliere_nom.toLowerCase()
                )
              "
              >{{ direction_immobiliere_nom }}</mat-checkbox
            >
          </div>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>
    <div class="filed">
      <div class="head">
        <label for="vocation">Vocation officielle</label>
        <span
          class="selection-count"
          *ngIf="selectedFilters['vocation_officielle']?.length"
        >
          {{ selectedFilters['vocation_officielle'].length }} sélection{{
            selectedFilters['vocation_officielle'].length > 1 ? 's' : ''
          }}
        </span>
      </div>
      <div
        class="container"
        *ngIf="!showFiltersMap['vocation_officielle']"
        (click)="toggleFilters('vocation_officielle')"
      >
        <span>Afficher les filtres</span>
        <svg
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#095797"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M6 9l6 6 6-6"></path>
        </svg>
      </div>
      <!-- Affichage du filtre uniquement si showFilters est vrai -->
      <div *ngIf="showFiltersMap['vocation_officielle']" class="container-true">
        <div
          (click)="toggleFilters('vocation_officielle')"
          class="filter-close"
        >
          <span>Masquer les filtres</span>
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#095797"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M6 9l6 -6 6 6"></path>
          </svg>
        </div>
        <div class="search-bar">
          <input
            class="search-input"
            type="text"
            [formControl]="searchControls['vocation_officielle']"
          />
          <img
            src="assets/images/loop.svg"
            alt="Rechercher"
            class="search-icon"
          />
        </div>
        <div class="checkbox-list">
          <div
            *ngFor="
              let vocation_officielle of filterOptions['vocation_officielle']
            "
            [value]="vocation_officielle"
          >
            <mat-checkbox
              class="custom-checkbox"
              (change)="
                onChange(
                  'vocation_officielle',
                  vocation_officielle.toLowerCase()
                )
              "
              [checked]="
                selectedFilters['vocation_officielle']?.includes(
                  vocation_officielle.toLowerCase()
                )
              "
              >{{ vocation_officielle }}</mat-checkbox
            >
          </div>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>
    <div
      class="ln"
      [ngClass]="{
        plus: !showingAdditionalFilters,
        minus: showingAdditionalFilters
      }"
      (click)="toggleShowAdditionalFilters()"
    >
      {{ showingAdditionalFilters ? 'Moins' : 'Plus' }} de filtres
    </div>
    <div *ngIf="showingAdditionalFilters">
      <div class="filed">
        <div class="head">
          <label for="nom_immeuble">Nom de l'immeuble</label>
          <span
            class="selection-count"
            *ngIf="selectedFilters['nom_immeuble']?.length"
          >
            {{ selectedFilters['nom_immeuble'].length }} sélection{{
              selectedFilters['nom_immeuble'].length > 1 ? 's' : ''
            }}
          </span>
        </div>
        <div
          class="container"
          *ngIf="!showFiltersMap['nom_immeuble']"
          (click)="toggleFilters('nom_immeuble')"
        >
          <span>Afficher les filtres</span>
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#095797"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M6 9l6 6 6-6"></path>
          </svg>
        </div>
        <!-- Affichage du filtre uniquement si showFilters est vrai -->
        <div *ngIf="showFiltersMap['nom_immeuble']" class="container-true">
          <div (click)="toggleFilters('nom_immeuble')" class="filter-close">
            <span>Masquer les filtres</span>
            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#095797"
              stroke-width="1"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M6 9l6 -6 6 6"></path>
            </svg>
          </div>
          <div class="search-bar">
            <input
              class="search-input"
              type="text"
              [formControl]="searchControls['nom_immeuble']"
            />
            <img
              src="assets/images/loop.svg"
              alt="Rechercher"
              class="search-icon"
            />
          </div>
          <div class="checkbox-list">
            <div
              *ngFor="let nom_immeuble of filterOptions['nom_immeuble']"
              [value]="nom_immeuble"
            >
              <mat-checkbox
                class="custom-checkbox"
                (change)="onChange('nom_immeuble', nom_immeuble.toLowerCase())"
                [checked]="
                  selectedFilters['nom_immeuble']?.includes(
                    nom_immeuble.toLowerCase()
                  )
                "
                >{{ nom_immeuble }}</mat-checkbox
              >
            </div>
          </div>
        </div>
      </div>

      <mat-divider></mat-divider>

      <mat-divider></mat-divider>
      <div class="filed">
        <div class="head">
          <label for="region">Région administrative</label>
          <span
            class="selection-count"
            *ngIf="selectedFilters['region_adminsitrative']?.length"
          >
            {{ selectedFilters['region_adminsitrative'].length }} sélection{{
              selectedFilters['region_adminsitrative'].length > 1 ? 's' : ''
            }}
          </span>
        </div>
        <div
          class="container"
          *ngIf="!showFiltersMap['region_adminsitrative']"
          (click)="toggleFilters('region_adminsitrative')"
        >
          <span>Afficher les filtres</span>
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#095797"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M6 9l6 6 6-6"></path>
          </svg>
        </div>
        <!-- Affichage du filtre uniquement si showFilters est vrai -->
        <div
          *ngIf="showFiltersMap['region_adminsitrative']"
          class="container-true"
        >
          <div
            (click)="toggleFilters('region_adminsitrative')"
            class="filter-close"
          >
            <span>Masquer les filtres</span>
            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#095797"
              stroke-width="1"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M6 9l6 -6 6 6"></path>
            </svg>
          </div>
          <div class="search-bar">
            <input
              class="search-input"
              type="text"
              [formControl]="searchControls['region_adminsitrative']"
            />
            <img
              src="assets/images/loop.svg"
              alt="Rechercher"
              class="search-icon"
            />
          </div>
          <div class="checkbox-list">
            <div
              *ngFor="
                let region_adminsitrative of filterOptions[
                  'region_adminsitrative'
                ]
              "
              [value]="region_adminsitrative"
            >
              <mat-checkbox
                class="custom-checkbox"
                (change)="
                  onChange(
                    'region_adminsitrative',
                    region_adminsitrative.toLowerCase()
                  )
                "
                [checked]="
                  selectedFilters['region_adminsitrative']?.includes(
                    region_adminsitrative.toLowerCase()
                  )
                "
                >{{ region_adminsitrative }}</mat-checkbox
              >
            </div>
          </div>
        </div>
      </div>

      <mat-divider></mat-divider>
      <div class="filed">
        <div class="head">
          <label for="type_propriete_ou_location">Type</label>
          <span
            class="selection-count"
            *ngIf="selectedFilters['type_propriete_ou_location']?.length"
          >
            {{ selectedFilters['type_propriete_ou_location'].length }}
            sélection{{
              selectedFilters['type_propriete_ou_location'].length > 1
                ? 's'
                : ''
            }}
          </span>
        </div>
        <div
          class="container"
          *ngIf="!showFiltersMap['type_propriete_ou_location']"
          (click)="toggleFilters('type_propriete_ou_location')"
        >
          <span>Afficher les filtres</span>
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#095797"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M6 9l6 6 6-6"></path>
          </svg>
        </div>
        <!-- Affichage du filtre uniquement si showFilters est vrai -->
        <div
          *ngIf="showFiltersMap['type_propriete_ou_location']"
          class="container-true"
        >
          <div
            (click)="toggleFilters('type_propriete_ou_location')"
            class="filter-close"
          >
            <span>Masquer les filtres</span>
            <svg
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#095797"
              stroke-width="1"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M6 9l6 -6 6 6"></path>
            </svg>
          </div>
          <div class="search-bar">
            <input
              class="search-input"
              type="text"
              [formControl]="searchControls['type_propriete_ou_location']"
            />
            <img
              src="assets/images/loop.svg"
              alt="Rechercher"
              class="search-icon"
            />
          </div>
          <div class="checkbox-list">
            <div
              *ngFor="
                let type_propriete_ou_location of filterOptions[
                  'type_propriete_ou_location'
                ]
              "
              [value]="type_propriete_ou_location"
            >
              <mat-checkbox
                class="custom-checkbox"
                (change)="
                  onChange(
                    'type_propriete_ou_location',
                    type_propriete_ou_location.toLowerCase()
                  )
                "
                [checked]="
                  selectedFilters['type_propriete_ou_location']?.includes(
                    type_propriete_ou_location.toLowerCase()
                  )
                "
                >{{
                  resolveTypeValue(type_propriete_ou_location)
                }}</mat-checkbox
              >
            </div>
          </div>
        </div>
      </div>

      <mat-divider></mat-divider>
      <div class="filed line">
        <input
          id="patrimonial"
          name="patrimonial"
          type="checkbox"
          [checked]="selectedFilters['immeuble_patrimonial']?.includes('oui')"
          (change)="onChange('immeuble_patrimonial', 'oui')"
        />
        <label for="patrimonial">Immeuble patrimonial</label>
      </div>
      <div class="filed line">
        <input
          id="avec"
          name="avec"
          type="checkbox"
          [checked]="selectedFilters['nom_immeuble']?.includes('%')"
          (change)="onChange('nom_immeuble', '%')"
        />
        <label for="avec">Immeuble avec dénomination</label>
      </div>
    </div>
  </form>
</div>
